import React, { useMemo, useState } from 'react';
export const CommentSuggestionsContext = /*#__PURE__*/ React.createContext({
    suggestion: null,
    setSuggestion: (suggestion)=>null,
    clearSuggestion: ()=>null
});
export const CommentSuggestionsContextProvider = ({ children })=>{
    const [suggestion, setSuggestion] = useState(null);
    const value = useMemo(()=>({
            suggestion,
            setSuggestion,
            clearSuggestion: ()=>setSuggestion(null)
        }), [
        suggestion
    ]);
    return /*#__PURE__*/ React.createElement(CommentSuggestionsContext.Provider, {
        value: value
    }, children);
};
CommentSuggestionsContextProvider.displayName = 'CommentSuggestionsContext';

//# sourceMappingURL=CommentSuggestionsContext.js.map